import { useQuery } from "@tanstack/react-query";
import {
  getIncident,
  getDashboardReport,
  getIncidentLogs,
} from "../api/report";

interface Props {
  incidentId?: string;
  contactId?: string;
  filterDays?: string;
  facility?: string;
}

function useReport({
  incidentId,
  contactId,
  filterDays,
  facility,
}: Props = {}) {
  const getIncidentById = useQuery(
    ["incident", incidentId],
    () => getIncident(incidentId as string),
    { enabled: !!incidentId }
  );

  const getDashboardReportByContactId = useQuery(
    ["dashboardReport", contactId],
    () =>
      getDashboardReport(
        contactId as string,
        filterDays as any,
        facility as string
      ),
    { enabled: !!contactId || !!filterDays || !!facility }
  );

  const getIncidentLogsByIncidentId = useQuery(
    ["incidentId", incidentId],
    () => getIncidentLogs(incidentId as string),
    { enabled: !!incidentId }
  );

  return {
    getIncidentById,
    getDashboardReportByContactId,
    getIncidentLogsByIncidentId,
  };
}

export default useReport;
